import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import DownloadIcon from "@mui/icons-material/Download";

import scarsoImg from "../../../../static/images/common/scarso_img.jpeg";
import heroImg from "../../../../static/images/common/Scarso-heroImage.png";
import certThumb from "../../../../static/images/common/certificato-iso-9001-thumb.jpg";
import certPdf from "../../../../static/images/common/certificato-iso-9001.pdf";

const Hero = () => (
	<Box
		sx={{
			position: "relative",
			minHeight: { xs: "70vh", md: "85vh" },
			display: "flex",
			alignItems: "center",
			color: "#fff",
			backgroundImage: `url(${heroImg})`,
			backgroundSize: "cover",
			backgroundPosition: "center",
			"&::before": {
				content: '""',
				position: "absolute",
				inset: 0,
				background:
					"linear-gradient(180deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.35) 50%, rgba(0,0,0,0.75) 100%)",
			},
		}}
	>
		<Container maxWidth="lg" sx={{ position: "relative", py: 8 }}>
			<Fade in timeout={1200}>
				<Box>
					<Typography
						variant="h1"
						sx={{
							fontSize: { xs: "2.6rem", sm: "3.6rem", md: "5rem" },
							lineHeight: 1.05,
							letterSpacing: "0.01em",
							textShadow: "0 2px 24px rgba(0,0,0,0.4)",
							maxWidth: "12ch",
						}}
					>
						Scarso Romualdo e Figli
					</Typography>
					<Box
						sx={{
							mt: 4,
							maxWidth: "44ch",
							borderLeft: "3px solid #ffd42d",
							pl: 3,
						}}
					>
						<Typography
							variant="h5"
							sx={{ fontWeight: 300, lineHeight: 1.4 }}
						>
							Macello avicolo.
						</Typography>
						<Typography
							variant="h5"
							sx={{ fontWeight: 300, lineHeight: 1.4 }}
						>
							Polli, capponi, galletti e galline.
						</Typography>
						<Typography
							variant="h5"
							sx={{ fontWeight: 300, lineHeight: 1.4, opacity: 0.85 }}
						>
							Macellati per conto di un numero limitato di committenti.
						</Typography>
					</Box>
				</Box>
			</Fade>
		</Container>
	</Box>
);

const Storia = () => (
	<Box component="section" sx={{ bgcolor: "#fafafa", py: { xs: 8, md: 12 } }}>
		<Container maxWidth="lg">
			<Grid container spacing={{ xs: 4, md: 8 }} sx={{ alignItems: "center" }}>
				<Grid size={{ xs: 12, md: 6 }}>
					<Typography
						variant="overline"
						sx={{ color: "primary.main", letterSpacing: "0.2em" }}
					>
						La nostra storia
					</Typography>
					<Typography variant="h3" sx={{ mt: 1, mb: 3, color: "#222" }}>
						Quattro generazioni
					</Typography>
					<Typography
						variant="body1"
						sx={{ mb: 2, color: "#333", fontSize: "1.1rem", lineHeight: 1.7 }}
					>
						È un'azienda storica, attiva nella macellazione di carni avicole,
						fornitura di uova, polli e galline, fondata dal Cav. Romualdo
						Scarso negli anni '60 a Rio di Ponte San Nicolò (PD).
					</Typography>
					<Typography
						variant="body1"
						sx={{ color: "#333", fontSize: "1.1rem", lineHeight: 1.7 }}
					>
						Romualdo Scarso ed arrivata oggi alla quarta generazione, fornisce
						tutta Italia con la propria azienda di trasporti refrigerati per
						garantire la catena del freddo.
					</Typography>
				</Grid>
				<Grid size={{ xs: 12, md: 6 }}>
					<Box
						component="img"
						src={scarsoImg}
						alt="Azienda Scarso Romualdo"
						sx={{
							width: "100%",
							height: { xs: 280, md: 480 },
							objectFit: "cover",
							objectPosition: "50% 0%",
							borderRadius: 2,
							boxShadow: "0 20px 40px -20px rgba(0,0,0,0.3)",
						}}
					/>
				</Grid>
			</Grid>
		</Container>
	</Box>
);

const Certificazioni = () => (
	<Box
		component="section"
		id="certificazioni"
		sx={{ bgcolor: "#fff", py: { xs: 8, md: 12 } }}
	>
		<Container maxWidth="lg">
			<Box sx={{ textAlign: "center", mb: { xs: 5, md: 8 } }}>
				<Typography
					variant="overline"
					sx={{ color: "primary.main", letterSpacing: "0.2em" }}
				>
					Qualità
				</Typography>
				<Typography variant="h3" sx={{ mt: 1, color: "#222" }}>
					Certificazione ISO 9001
				</Typography>
			</Box>
			<Grid
				container
				spacing={{ xs: 4, md: 6 }}
				sx={{ alignItems: "center", justifyContent: "center" }}
			>
				<Grid size={{ xs: 12, sm: 8, md: 5 }}>
					<Box
						component="a"
						href={certPdf}
						target="_blank"
						rel="noopener noreferrer"
						sx={{
							display: "block",
							border: "1px solid rgba(0,0,0,0.08)",
							borderRadius: 2,
							overflow: "hidden",
							boxShadow: "0 12px 30px -15px rgba(0,0,0,0.25)",
							transition: "transform 200ms ease, box-shadow 200ms ease",
							"&:hover": {
								transform: "translateY(-4px)",
								boxShadow: "0 20px 40px -15px rgba(0,0,0,0.35)",
							},
						}}
					>
						<Box
							component="img"
							src={certThumb}
							alt="Anteprima Certificato ISO 9001"
							sx={{ width: "100%", display: "block" }}
						/>
					</Box>
				</Grid>
				<Grid size={{ xs: 12, md: 5 }}>
					<Button
						variant="contained"
						color="primary"
						size="large"
						component="a"
						href={certPdf}
						target="_blank"
						rel="noopener noreferrer"
						download="Certificato-ISO-9001-Scarso-Romualdo.pdf"
						startIcon={<DownloadIcon />}
						sx={{
							color: "#222",
							fontWeight: 500,
							px: 3,
						}}
					>
						Scarica il certificato (PDF)
					</Button>
				</Grid>
			</Grid>
		</Container>
	</Box>
);

const HomePage = () => (
	<>
		<Hero />
		<Storia />
		<Certificazioni />
	</>
);

export default HomePage;
